// extracted by mini-css-extract-plugin
module.exports = {"Profile":"Profile_Profile__T0eR4","ProfileWrap":"Profile_ProfileWrap__3Y6d_"};